(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotificationsDeleteController',NotificationsDeleteController);

    NotificationsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Notifications'];

    function NotificationsDeleteController($uibModalInstance, entity, Notifications) {
        var vm = this;

        vm.notifications = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Notifications.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
